// download url
const createIframeDownloadFile = url => {
    let iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = url;
    iframe.onload = function () {
        document.body.removeChild(iframe);
    }
    document.body.appendChild(iframe);
}

const createDownloadFile = (content, fileName) => {
    let aElement = document.createElement('a');
    aElement.download = fileName;
    if(typeof content === 'string') {
        aElement.href = content;
    } else {
        let blob = new Blob([content], {type: content.type});
        aElement.href = URL.createObjectURL(blob);
        URL.revokeObjectURL(blob);
    }
    document.body.appendChild(aElement);
    aElement.click();
    document.body.removeChild(aElement);
}

/**
 * 将时间戳格式化
 * @param {*} time 时间戳 1510908337
 * @param {*} cFormat 格式 {y}-{m}-{d} {h}:{i}:{s}
 */
const parseTimestamp = (time, cFormat) => {
    if (arguments.length === 0) {
      return null;
    }
  
    if ((time + '').length === 10) {
      time = +time * 1000
    }
  
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
    let date;
    if (typeof time == 'undefined' || time == '') {
      return null;
    } else if (typeof time == 'object') {
      date = time;
    } else {
      date = new Date(parseInt(time));
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    };
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
      let value = formatObj[key];
      if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
      if (result.length > 0 && value < 10) {
        value = '0' + value;
      }
      return value || 0;
    });
    return time_str;
  }

  
  /**
   * 将默认Date格式化
   * @param {*} time Thu Nov 16 15:16:50 CST 2017
   * @param {*} cFormat yyyy-MM-dd hh:mm
   */
  const parseDateFilter = (time, cFormat) => {
    if (arguments.length === 0 || time === '') {
      return null;
    }
    var fmt = cFormat || 'yyyy-MM-dd hh:mm:ss';
    var date = new Date(time);
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    };
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + '';
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length));
      }
    }
    return fmt;
  }


  const parseDayTime = (day) => {
    var myDate=new Date()
    var time = myDate.setDate(myDate.getDate()-day)
    return time
  }
  
      // 比较时间大小
const compareTime = function (start = null, end = null) {
  if (start === null || end === null) {
    return false
  }
  start = new Date(start.replace(/-/g, '/')).getTime()
  end = new Date(end.replace(/-/g, '/')).getTime()
  if (start > end) {
    return true
  } else {
    return false
  }
}

const base = {
    createIframeDownloadFile,
    createDownloadFile,
    parseTimestamp,
    parseDateFilter,
    parseDayTime,
    compareTime
}

export default base;



// WEBPACK FOOTER //
// ./src/api/base.js